<div
    class="tw-bg-white tw-rounded-[10px] tw-shadow-md tw-p-[20px] tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-[19px] tw-h-full tw-min-h-[466px]"
>
    <ng-container *ngIf="image">
        <div
            class="tw-w-[255px] tw-h-[165px] tw-border-2 tw-border-[#0000001A] tw-p-[25px] tw-flex tw-items-center tw-justify-center tw-rounded-[10px] tw-overflow-hidden"
        >
            <img
                [src]="image"
                [alt]="title"
                class="tw-w-full tw-h-full tw-object-contain tw-rounded-md"
            />
        </div>
    </ng-container>
    <div
        class="tw-flex tw-flex-col tw-gap-[14px] tw-items-center tw-justify-center- w-full tw-flex-grow"
    >
        <span
            class="tw-text-[#024B3F] tw-font-bold tw-text-[16px] tw-h-[38.4px]"
        >
            {{ title }}
        </span>
        <div class="tw-flex tw-flex-col tw-gap-[10px]">
            <span
                class="tw-font-semibold tw-text-black tw-text-[14px] tw-h-[34px]"
            >
                {{ subtitle }}
            </span>
            <span
                class="tw-text-[#7B7575] tw-text-[14px] tw-font-medium default-html"
                [innerHTML]="description"
            ></span>
        </div>
    </div>

    <hr class="tw-w-full tw-border-2 tw-border-[#6D7A871A]" />

    <button
        [attr.ga-event-id]="ga?.id"
        [attr.ga-event-category]="ga?.category"
        [attr.ga-event-label]="ga?.label"
        ga-track="track"
        class="tw-max-w-[186px] tw-max-h-[45px] tw-px-[32px] tw-py-[12px] tw-bg-[#024B3F] tw-rounded-[32px] hover:tw-bg-[#036B56] tw-transition-colors tw-cursor-pointer"
        (click)="onButtonClick()"
        type="button"
    >
        <span
            class="tw-text-white tw-text-[16px] tw-font-semibold tw-pointer-events-none"
            >{{ buttonText }}</span
        >
    </button>
</div>
